import { Button } from 'components/ui/button';
import { IconPause, IconPlay } from 'components/ui/icons';
import React, { useContext } from 'react';
import { DensityMapControlsContext } from '../context';
import { DensityMapControlsEventType } from '../../use-density-map-controls/event-type';

export const Autopilot: React.FC = props => {
  const context = useContext(DensityMapControlsContext)
  if (!context) throw new Error("ControlPanelContext required");
  
  const { eventHandler, autopilotIsOn } = context
  const dispatch = (e: CustomEvent) => {
    eventHandler && eventHandler(e);
  }

  return (
    <section className="pilot">
      <Button
        key="btn_toggle_autopilot"
        variant="subtle"
        onClick={() => dispatch(new CustomEvent(DensityMapControlsEventType.TOGGLE_AUTOPILOT))}
        >
        {autopilotIsOn ? <IconPause size="small" /> : <IconPlay size="small" />} Autopilot
      </Button>
    </section>
  )
}